module.exports = __webpack_public_path__ + "img/Xian-Sheng_Hua@2x.71a2a48a.png";